exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--4-1!../../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/deeppurple-amber.css"), "");

// module
exports.push([module.id, "body {\n  position: absolute;\n  width: 100vw;\n  height: 100vh; }\n\n#slider {\n  text-align: center; }\n\ntable {\n  background-color: #1D1D1B; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main